<style lang="less">
  @import './styles/menu.less';
</style>

<template>
  <div :style="{background: '#3A3F63'}" class="ivu-shrinkable-menu">
    <slot name="top"/>
    <scoll-bar ref="scrollBar" :height="sidebarHeight">
      <sidebar-menu
        v-show="!shrink"
        menu-theme="dark"
        :menu-list="menuList"
        :open-names="openNames"
        @on-change="handleChange"
        @on-open-change="handleOpenChange"
      />
      <sidebar-menu-shrink
        v-show="shrink"
        menu-theme="dark"
        :menu-list="menuList"
        :icon-color="shrinkIconColor"
        @on-change="handleChange"
      />
    </scoll-bar>
  </div>
</template>

<script>
  import sidebarMenu from './components/sidebarMenu.vue'
  import sidebarMenuShrink from './components/sidebarMenuShrink.vue'
  import ScollBar from '@/views/components/scroll-bar/vue-scroller-bars'

  export default {
    name: 'shrinkableMenu',
    components: {
      sidebarMenu,
      sidebarMenuShrink,
      ScollBar
    },
    props: {
      shrink: {
        type: Boolean,
        default: false
      },
      menuList: {
        type: Array,
        required: true
      },
      theme: {
        type: String,
        default: 'dark'
      },
      beforePush: {
        type: Function
      },
      openNames: {
        type: Array
      }
    },
    data () {
      return {
        height: window.innerHeight,
        topHeight: 0
      }
    },
    computed: {
      bgColor () {
        return this.theme === 'dark' ? '#3A3F63' : '#3A3F63'
      },
      shrinkIconColor () {
        return this.theme === 'dark' ? '#3A3F63' : '#3A3F63'
      },
      sidebarHeight () {
        return this.height - this.topHeight
      }
    },
    mounted () {
      this.calcTopHeight()

      window.onresize = () => {
        this.height = window.innerHeight
      }
    },
    updated () {
      this.calcTopHeight()
    },
    methods: {
      resize () {
        this['$refs'].scrollBar.resize()
      },
      calcTopHeight () {
        const elm = this['$slots'].top[0].elm
        this.topHeight = elm ? elm.clientHeight : 0
      },
      handleChange (name) {
        let willpush = true
        if (this.beforePush !== undefined) {
          if (!this.beforePush(name)) {
            willpush = false
          }
        }
        if (willpush) {
          this.$router.push({
            name: name
          })
        }
        this.$emit('on-change', name)
      },
      handleOpenChange (openNames) {
        setTimeout(() => {
          this.resize()
        }, 300)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/components/shrinkable-menu/shrinkable-menu.vue